import { useRequestHeaders } from '#imports'

/**
 * Retrieve whether the current environment is the end-to-end testing environment based on the user agent.
 *
 * @example
 * const isE2ETestingEnvironment = useIsE2ETestingEnvironment()
 */
export function useIsE2ETestingEnvironment() {
  const headers = useRequestHeaders()

  if (headers['user-agent']) {
    return headers['user-agent'] === 'MrFatUserAgent'
  }

  return window?.navigator?.userAgent === 'MrFatUserAgent'
}
